import React from 'react';
import { Image as ImageIcon, Film, Globe, ExternalLink, Radio, LayoutGrid, File } from 'lucide-react';

/**
 * Centralized media type icon config.
 * All icons use Lucide React for consistency across the app.
 */
export const MEDIA_TYPE_CONFIG = {
    image:        { Icon: ImageIcon,    color: '#ec4899', bg: 'linear-gradient(135deg,#fdf2f8,#fce7f3)' },
    video:        { Icon: Film,         color: '#6366f1', bg: 'linear-gradient(135deg,#eef2ff,#e0e7ff)' },
    videourl:     { Icon: ExternalLink, color: '#8b5cf6', bg: 'linear-gradient(135deg,#f5f3ff,#ede9fe)' },
    web:          { Icon: Globe,        color: '#14b8a6', bg: 'linear-gradient(135deg,#f0fdfa,#ccfbf1)' },
    streamingurl: { Icon: Radio,        color: '#f59e0b', bg: 'linear-gradient(135deg,#fffbeb,#fef3c7)' },
    all:          { Icon: LayoutGrid,   color: '#64748b', bg: 'linear-gradient(135deg,#f8fafc,#f1f5f9)' },
    default:      { Icon: File,         color: '#64748b', bg: 'linear-gradient(135deg,#f8fafc,#f1f5f9)' },
};

/**
 * Returns a styled Lucide icon element for a given media FileType string.
 * @param {string} fileType  - e.g. "image", "video", "web", "videourl", "streamingurl"
 * @param {number} size      - icon size in px (default 18)
 * @param {string} colorOverride - optional color override
 */
export function getMediaTypeIcon(fileType, size = 18, colorOverride) {
    const type = (fileType || '').toLowerCase();
    const config = MEDIA_TYPE_CONFIG[type] || MEDIA_TYPE_CONFIG.default;
    const { Icon, color } = config;
    return <Icon size={size} color={colorOverride || color} />;
}

/**
 * Returns the bg gradient string for a given media type (for icon circles/badges).
 */
export function getMediaTypeBg(fileType) {
    const type = (fileType || '').toLowerCase();
    return (MEDIA_TYPE_CONFIG[type] || MEDIA_TYPE_CONFIG.default).bg;
}
